import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PowerOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"power_off"}/>
}
